const IMG = "/img/logos";

const LOGOS = [
  { kind: "img", src: `${IMG}/vca.white.png`, name: "VCA Animal Hospitals" },
  { kind: "img", src: `${IMG}/millers-electric.white.png`, name: "Miller's Electric" },
  { kind: "img", src: `${IMG}/builders-steel.white.png`, name: "Builders Steel Co" },
  { kind: "img", src: `${IMG}/hammerhead.white.png`, name: "Hammerhead Aviation" },
  { kind: "img", src: `${IMG}/royal-flush.svg`, name: "Royal Flush Plumbing" },
  { kind: "img", src: `${IMG}/aca.white.png`, name: "ACA Business Club" },
  { kind: "text", name: "Vancouver Heating and Air", label: "Vancouver Heating", sub: "AND AIR" },
  { kind: "img", src: `${IMG}/iq.white.png`, name: "IQ Manufacturing" },
  { kind: "img", src: `${IMG}/fullypromoted.white.png`, name: "Fully Promoted" },
  { kind: "img", src: `${IMG}/cross.white.png`, name: "Blue Cross" },
  { kind: "img", src: `${IMG}/bsg.white.png`, name: "BSG Advisors" },
  { kind: "img", src: `${IMG}/floodmaster.white.png`, name: "FloodMaster" },
  { kind: "img", src: `${IMG}/kw.white.png`, name: "Keller Williams Realty" },
  { kind: "img", src: `${IMG}/tsc.white.png`, name: "TSC Restoration" },
  { kind: "img", src: `${IMG}/bukaty.white.png`, name: "Bukaty Companies" },
  { kind: "img", src: `${IMG}/dlm.white.png`, name: "DLM Commercial" },
  { kind: "img", src: `${IMG}/stoltz.white.png`, name: "Robert W. Stoltz" },
  { kind: "img", src: `${IMG}/spree.white.png`, name: "Spree", tall: true },
];

function CellContent({ logo }) {
  if (logo.kind === "img") {
    return (
      <img
        src={logo.src}
        alt={logo.name}
        loading="lazy"
        className={`w-auto max-w-[64%] object-contain opacity-90 [filter:brightness(0)_invert(1)] ${
          logo.tall ? "max-h-20" : "max-h-11"
        }`}
      />
    );
  }
  return (
    <div
      className={`text-center leading-tight text-white/95 ${logo.cls || ""} ${
        logo.boxed ? "border border-white/90 px-4 py-1" : ""
      }`}
    >
      <span>{logo.label}</span>
      {logo.sub ? (
        <span className="block font-mono text-[11px] tracking-[0.3em] text-white/80">
          {logo.sub}
        </span>
      ) : null}
    </div>
  );
}

function LogoCell({ logo }) {
  const slug = logo.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <div
      data-testid={`logo-cell-${slug}`}
      className="flex h-28 items-center justify-center border-slate-200/10 px-6 [&:not(:nth-child(6n))]:border-r max-sm:[&:nth-child(-n+12)]:border-b sm:max-lg:[&:not(:nth-child(4n))]:border-r sm:max-lg:[&:nth-child(-n+12)]:border-b lg:[&:not(:nth-child(6n))]:border-r lg:[&:not(:nth-last-child(-n+6))]:border-b"
    >
      <CellContent logo={logo} />
    </div>
  );
}

export default function LogoWall() {
  return (
    <section
      data-testid="logo-wall"
      className="bg-[#0B0F19] py-16 md:py-20 lg:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <h2 className="mx-auto max-w-3xl text-center font-display text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
          Working with Emerging Brands and Local Businesses
        </h2>
        <div className="mt-12 grid grid-cols-2 rounded-2xl border border-slate-200/10 sm:grid-cols-4 lg:grid-cols-6">
          {LOGOS.map((logo) => (
            <LogoCell key={logo.name} logo={logo} />
          ))}
        </div>
      </div>
    </section>
  );
}
